module.exports = __webpack_public_path__ + "img/FUNDAMENTAL.c0659461.svg";